<ion-row>
  <ion-item
    class="terms-and-conditions"
    *ngIf="agreementCheckboxControl"
    lines="none"
  >
    <form [formGroup]="addBankAccountForm">
      <ion-checkbox
        formControlName="agreementCheckbox"
        data-cy="add-bank-account-modal-TAC-agreement-checkbox"
        labelPlacement="end"
        justify="start"
        ><span data-cy="add-bank-account-modal-TAC-agreement-label">
          {{ 'i18n.payments.addBankAccountModal.agreementText' | translate }}
          <a
            href="https://www.usfoods.com/policies/index.html"
            target="_blank"
            (click)="$event.stopPropagation()"
          >
            {{
              'i18n.payments.addBankAccountModal.termsAndConditions' | translate
            }}
          </a>
        </span></ion-checkbox
      >
    </form>
  </ion-item>
</ion-row>
